module.exports = __webpack_public_path__ + "img/91405.8051b336.svg";